import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseResponseModel, ResponseModel } from '@models/app.model';
import {
    ChangeLockPartnerRequest,
    ChangeStatusPartnerRequest,
    CreatePartner,
    CreatePartnerRequest,
    DeletePartnerRequest,
    IncreaseCreditRequest,
    PartnerBalanceTransactionRes,
    PartnerInfo,
    PartnerListResponse,
    SearchPartnerBalanceTransaction,
    SearchPartnerParams,
    SearchPartnerRequest,
    SearchPartnerResponse,
    UpdatePartner,
    UpdatePartnerRequest,
} from '@models/partner.model';
import { HttpService } from '@services/http.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PartnerService {
    constructor(private httpService: HttpService) {}

    public searchListPartnerInfoManage(
        reqParams: SearchPartnerRequest
    ): Observable<BaseResponseModel<SearchPartnerResponse[]>> {
        return this.httpService.get('PartnerInfo/SearchListPartnerInfoManage', {
            params: new HttpParams({ fromObject: { ...reqParams } }),
        });
    }

    public changeStatusPartnerInfo(
        reqBody: ChangeStatusPartnerRequest
    ): Observable<BaseResponseModel<null>> {
        return this.httpService.post('PartnerInfo/ChangeStatusPartnerInfo', reqBody);
    }

    public getDetailPartnerInfoManageById(
        id: number,
        disableClick = false
    ): Observable<BaseResponseModel<SearchPartnerResponse>> {
        return this.httpService.get(`PartnerInfo/DetailPartnerInfoManage?Id=${id}`, {
            updateLoading: disableClick,
        });
    }

    public deletePartnerInfo(Id: number): Observable<BaseResponseModel<null>> {
        return this.httpService.post('PartnerInfo/DeletePartnerInfo', { Id: Id });
    }

    public createPartnerInfo(req: CreatePartnerRequest): Observable<ResponseModel> {
        return this.httpService.post('PartnerInfo/CreatePartnerInfo', req, { updateLoading: true });
    }

    public updatePartnerInfo(req: UpdatePartnerRequest): Observable<ResponseModel> {
        return this.httpService.post('PartnerInfo/UpdatePartnerInfo', req, { updateLoading: true });
    }

    public getPartnerList(): Observable<BaseResponseModel<PartnerListResponse[]>> {
        return this.httpService.get('Partner/GetList');
    }

    public searchPartnerByParams(
        reqParams: SearchPartnerParams
    ): Observable<BaseResponseModel<SearchPartnerResponse[]>> {
        return this.httpService.get('Partner/SearchList', {
            params: new HttpParams({
                fromObject: {
                    ...reqParams,
                },
            }),
        });
    }

    public changeLockPartner(reqBody: ChangeLockPartnerRequest): Observable<ResponseModel> {
        return this.httpService.post('Partner/ChangeActive', reqBody);
    }

    public getPartnerInfo(Id: string): Observable<BaseResponseModel<PartnerInfo[]>> {
        return this.httpService.get('Partner/Detail', {
            params: new HttpParams({
                fromObject: {
                    Id,
                },
            }),
        });
    }

    public searchListPartnerBalanceTransaction(
        reqParams: SearchPartnerBalanceTransaction
    ): Observable<PartnerBalanceTransactionRes[]> {
        return this.httpService.get('Partner/GetPartnerBalanceTransaction', {
            params: new HttpParams({
                fromObject: {
                    ...reqParams,
                },
            }),
        });
    }

    public createIncreaseCreditRequest(reqBody: IncreaseCreditRequest): Observable<ResponseModel> {
        return this.httpService.post('Partner/TopupBalanceManual', reqBody);
    }

    public revertIncreaseCreditRequest(reqBody: IncreaseCreditRequest): Observable<ResponseModel> {
        return this.httpService.post('Partner/ReverseBalanceManual', reqBody);
    }

    public createPartner(reqBody: CreatePartner): Observable<ResponseModel> {
        return this.httpService.post('Partner/Create', reqBody);
    }

    public updatePartner(reqBody: UpdatePartner): Observable<ResponseModel> {
        return this.httpService.post('Partner/Update', reqBody);
    }

    public deletePartner(reqBody: DeletePartnerRequest): Observable<ResponseModel> {
        return this.httpService.post('Partner/Delete', reqBody);
    }
    
}
